import React from 'react'
import { Link } from 'react-router-dom'
import OnboardingTip from './OnboardingTip'
import Resource from '../Resource'
import { EduSectionTitle } from '../constants'

function toMMSS(seconds) {
  return `${Math.floor(seconds / 60)}:${seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60}`
}

export default class VideosContainer extends React.Component {
  render() {
    const { me } = this.props

    return (
      <div className="screen videos screen-flex-wrapper">
        <div className="navigation-bar">
          <div className="title">Videos</div>
        </div>
        <OnboardingTip text={'Tap a video to preview it or begin an exercise session.'} />
        <div className="screen-scroll-content">
          <Resource collection path={['videos']} placeholder={[]}>
            {(sections) => {
              const edu = sections.find((s) => s.title === EduSectionTitle)
              const eduComplete =
                !edu || edu.videos.filter((v) => v.complete).length === edu.videos.length

              return sections.map(({ title, videos }, idx) => {
                const locked =
                  title !== EduSectionTitle && !eduComplete && !(me.role === 1 || me.role === 2)
                return (
                  <div className={`section ${locked && 'locked'}`} key={title}>
                    <h3>{title}</h3>
                    <div className="videos">
                      {videos.map((video) => (
                        <Link
                          to={`/mobile/videos/${video.id}`}
                          className="video"
                          key={video.id}
                          style={{ backgroundImage: `url(${video.thumbnailImageURL})` }}
                        >
                          <div className="duration">{toMMSS(video.duration)}</div>
                          {video.complete && (
                            <img
                              src={require('../images/icon_completed.png')}
                              className="completed"
                              alt="completed"
                            />
                          )}
                        </Link>
                      ))}
                    </div>
                    {locked && (
                      <div className="locked-notice">
                        Unlock this series by watching the videos above!
                      </div>
                    )}
                  </div>
                )
              })
            }}
          </Resource>
        </div>
      </div>
    )
  }
}
